import { ColourPickerV2 } from "./colour-picker-v2";

import type { usePopover } from "../../../../utils/hooks/use-popover";
import type { FC } from "react";

export const ColourPicker: FC<{
  popover: ReturnType<typeof usePopover<HTMLElement>>;
  onChange: (color: string, skipAddingToHistoryStack?: boolean) => void;
  colour: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
}> = ({ popover, onChange, colour, inputRef }) => (
  <ColourPickerV2 popover={popover} onChange={onChange} colour={colour} inputRef={inputRef} />
);
